import { ChangeDetectorRef, Component,Input, OnInit } from '@angular/core';
import { ProductService } from 'src/app/service/product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from 'src/app/shared/services/cart.service';
import { HelperService } from 'src/app/service/helper.service';

@Component({
  selector: 'app-product-details-area',
  templateUrl: './product-details-area.component.html',
  styleUrls: ['./product-details-area.component.scss']
})
export class ProductDetailsAreaComponent implements OnInit{
  @Input() product:any | undefined;
  productData:any = null;
  imagePath:any = null;
  productSpecification:any = [];

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private router: Router,
    public cartService: CartService,
    public helper:HelperService,
  ) {}

  ngOnInit(): void {
    // this.productService.product(this.route.snapshot.params['id']).subscribe({
    //   next:(res:any) => {
        if(this.product){
          console.log(this.product);
          this.productData = this.product.product;
          this.imagePath = this.product.path;
          this.productSpecification = this.product.specification;
          this.activeImg = (this.product.product.product_image)?this.product.path+this.product.product.product_image:'assets/img/dummy/product.png';
        }
        
    //   },
    //   error:(err:any)=> {

    //   },
    //   complete:()=> {

    //   },
    // })
  }

  activeImg: string | undefined;

  handleImageActive(img: string) {
    // alert(img);
    this.activeImg = this.imagePath+img;
  }

  downloadpdf() {
    let fileName = 'product_' + this.route.snapshot.params['id'] + '.pdf';
    this.productService.downloadPDF(this.route.snapshot.params['id']).subscribe({
      next:(res:any) => {
        console.log(res);
        this.helper.blobToFile(res, "application/octet-stream", fileName);
      },
    });

    /* res => {
      this.blobToFile(res, "application/octet-stream", this.fileName);
    }, error => {
      console.log(error);
    }*/
  }
}
